<template>
  <div class="city-main-kv-container">
    <div class="city-main-kv-wrapper">
      <div class="city-kv-container">
        <div class="city-main-kv-frame">
          <img class="city-main-kv" :src="banner" />
          <div class="city-kv-logo" />
        </div>
        <div class="video-item">
          <div
            class="poster-container"
            :style="{ backgroundImage: `url(${videoItem.img})` }"
            @click="jumpOther(videoItem.url)"
            v-rseat="'click_carnival_city_video'"
          >
            <div class="mask" />
            <i class="icon-play" />
          </div>
          <div class="video-title">{{ videoItem.text }}</div>
        </div>
        <CloudAlbum :jump-card="jumpCard" />
      </div>
      <div class="city-kv-swiper-container">
        <poster-swiper :pic-list="cardList" />
      </div>
    </div>
  </div>
</template>
<script>
import PosterSwiper from '@/components/carnival2020/poster-swiper.vue'
import CloudAlbum from '@/components/carnival2020/cloud-album.vue'

const MAX_TITLE_LENGTH = 12

export default {
  components: {
    PosterSwiper,
    CloudAlbum,
  },
  props: {
    banner: {
      type: String,
      default: '',
    },
    videoList: {
      type: Array,
      default: () => [],
    },
    jumpCard: {
      type: Object,
      default: () => {},
    },
    cardList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      videoItem: this.videoList[0] || {},
    }
  },
  methods: {
    formatTitle(title) {
      if (!title) {
        return ''
      }
      let count = 0
      let index = -1
      let sliceLength = -1
      title.replace(/([\x20-\xff])|([^\x20-\xff])/g, (match, p1, p2) => {
        index += 1
        if (p1) {
          count += 3
        }
        if (p2) {
          count += 2
        }
        if (Math.floor(count / 3) === MAX_TITLE_LENGTH) {
          sliceLength = index
        }
      })
      return sliceLength > -1 ? `${title.substring(0, sliceLength + 1)}...` : title
    },
    jumpOther(url) {
      window.open(url)
    },
  },
}
</script>
<style lang="less">
.city-main-kv-container {
  position: relative;
  top: -112px;
  background: transparent url('~@/assets/carnival2020/city-info/city-kv-bg.jpg') top center no-repeat;
  background-size: 1920px auto;
  width: 100%;
  height: 887px;
  position: relative;
  // 兼容ie浏览器
  .city-main-kv-wrapper {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }
  .city-kv-container {
    position: relative;
    top: 158px;
    margin: 0 auto;
    width: 1100px;
    &:after {
      content: '';
      display: block;
      clear: both;
    }
    .city-main-kv-frame {
      position: relative;
      float: left;
      width: 712px;
      height: 393px;
      background: transparent url('~@/assets/carnival2020/city-info/city-main-kv-frame.png') center center no-repeat;
      background-size: contain;
    }
    .city-main-kv {
      position: absolute;
      top: 28px;
      left: 30px;
      width: 652px;
      height: 335px;
      object-fit: cover;
    }
    .city-kv-logo {
      display: none;
      position: absolute;
      top: 28px;
      left: 30px;
      width: 129px;
      height: 47px;
      background: transparent url('~@/assets/carnival2020/logo.png') center center no-repeat;
      background-size: cover;
    }
    .video-item {
      position: relative;
      float: left;
      width: 377px;
      height: 251px;
      background: transparent url('~@/assets/carnival2020/city-info/video-frame.png') center center no-repeat;
      background-size: contain;
      margin: 16px 0 0 10px;
      cursor: pointer;
      .poster-container {
        position: absolute;
        left: 16px;
        top: 14px;
        width: 347px;
        height: 189px;
        background: transparent none center center no-repeat;
        background-size: cover;
        .mask {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-color: rgba(0, 0, 0, 0.3);
        }
        .icon-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -52%);
          width: 109px;
          height: 109px;
          background: transparent url('~@/assets/carnival2020/city-info/icon-play.png') center center no-repeat;
          background-size: cover;
        }
      }
      .video-title {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 9px 115px 10px 14px;
        font-size: 20px;
        color: #fff;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .btn-cloud-wrapper {
      float: left;
      margin-left: 8px;
    }
  }
  .city-kv-swiper-container {
    position: relative;
    top: 200px;
    margin: 0 auto;
    width: 1072px;
    height: 254px;
  }
  &::after {
    display: block;
    content: '';
    position: absolute;
    bottom: -141px;
    left: 0;
    width: 100%;
    height: 142px;
    background: url('~@/assets/carnival2020/bg_bevel.png') top center no-repeat;
    background-size: 1920px auto;
  }
}
</style>
